import generateConfig from './generate';

export default generateConfig(DEPLOY_ENV);
